import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { SIZES } from '../styles/theme'
import { fixedAssets } from 'src/containers/PreCache'
import { useHistory, useLocation } from 'react-router-dom'
import routes from 'src/routes'
import { useDispatch } from 'react-redux'
import { showGlobalModal } from 'src/ducks/layout'
import { GlobalModalTypes } from './GlobalModals/GlobalModalContainer'
import Amplitude from 'src/utils/amplitudeHelper'
import { logoutUser } from 'src/ducks/auth'

const Wrapper = styled.div`
  position: fixed;
  top: 110%;
  left: 0;
  right: 0;
  z-index: 50;
  transition: 1s;
  height: 120px;
  background: url(${fixedAssets.bottom});
  background-size: cover;
  background-position: center bottom;
  animation: slideUp 700ms 1800ms forwards;

  .waviy {
    position: relative;
    font-size: 15px;
    top: 12%;
    margin: 0;
    width: 100%;
    text-align: center;
    cursor: pointer;
    font-weight: 700 !important;
  }
  .waviy span {
    color: #44ABE2;
    filter: brightness(1.5);
    position: relative;
    display: inline-block;
    animation: waviy 3s infinite;
    animation-delay: calc(.1s * var(--i));
  }
  #upIcon {
    position: absolute;
    left: 50%;
    margin-top: -25px;
    transform: translateX(-50%) scale(1);
    background: #000;
    border-radius: 50%;
    padding: 0.5rem;
    filter: brightness(1.1);
    transition: all 200ms ease;
    cursor: pointer;
    animation: buttonAnimated 3s infinite;
    &:hover {
      filter: brightness(1.5);
    }
  }
  .rotateDown > img {
    transition: all 700ms ease;
    transform: rotate(180deg);
  }
  .rotateUp > img {
    transition: all 700ms ease;
    transform: rotate(0deg);
  }
  #navTabs {
    position: absolute;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 1));
    bottom: 120px;
    left: 0;
    right: 0;
    z-index: 0;
    transition: all 500ms ease;
    padding-bottom: ${(props) => (props.open ? '1rem' : '0')};
    height: ${(props) => (props.open ? '180px' : '0')};
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      height: 40px;
      margin: 0 12px;
      text-align: center;
      display: ${(props) => (props.open ? 'block' : 'none')};
      transition: all 1500ms ease;
      opacity: ${(props) => (props.open ? '1' : '0')};
      &:hover {
        p, img {
          filter: brightness(1.5);
          cursor: pointer;
        }
      }
    }
    p {
      color: #44ABE2;
      margin: 4px 0;
      font-size: 12px;
      font-weight: 700;
    }
    img {
      height: 100%;
      display: block;
      margin: 0 auto;
    }
  }
  @keyframes buttonAnimated {
    50% { 
      box-shadow: 0px -10px 34px -2px #44ABE2;
      margin-top: -35px; 
      transform: translateX(-50%) scale(1.15);
    }
    100% { 
      transform: translateX(-50%) scale(1);
    }
  }
  @keyframes waviy {
    0%, 40%, 100% {
      transform: translateY(0)
    }
    20% {
      transform: translateY(-3px)
    }
}
  @keyframes slideUp {
    to { transform: translateY(-140%); }
  }
  ${SIZES.mobile} {
    height: 100px;
    #navTabs {
      bottom: 100px;
      padding-bottom: ${(props) => (props.open ? '1.5rem' : '0')};
      height: ${(props) => (props.open ? '120px' : '0')};
      div {
        height: 25px;
        margin: 0 8px;
        p {
          font-weight: 400;
          font-size: 8px;
        }
      }
    }
  }
`
export default function BottomNavigation({ currentUser }) {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const [showNav, setShowNav] = useState(false)

  useEffect(() => {
    setShowNav(false)
  }, [location])

  const showHelpDesk = () => {
    const cpt = window.chaport
    cpt.on('ready', function () {
      cpt.setVisitorData({
        name: currentUser.fullName,
        email: currentUser.email,
      })
      cpt.open()
    })
    cpt.on('collapsed', function () {
      cpt.close()
    })
    Amplitude.clickHelpDesk()
  }

  const handleNavClick = (type) => {
    if (type === 'agenda') {
      Amplitude.click('Agenda & Speakers')
      dispatch(showGlobalModal(GlobalModalTypes.AgendaSpeakers))
    }
    if (type === 'exhibition') {
      dispatch(showGlobalModal(GlobalModalTypes.EntrySelection))
    }
    if (type === 'helpdesk') {
      showHelpDesk()
    }
    if (type === 'logout') {
      handleLogout()
    }
  }
  const handleLogout = () => {
    Amplitude.clickLogout()
    logoutUser(dispatch, currentUser, location.pathname, 'You have logged out')
  }

  const navigateTo = (route) => {
    history.push(route)
    setShowNav(!showNav)
  }

  const toggleNav = () => {
    setShowNav(!showNav)
  }

  return (
    <Wrapper open={showNav}>
      <div id="navTabs">
        <div onClick={() => navigateTo(routes.lobby)}>
          <img src={fixedAssets.homeNav} alt="nav icon" />
          <p>Home</p>
        </div>
        <div onClick={() => handleNavClick("agenda")}>
          <img src={fixedAssets.agendaNav} alt="nav icon" />
          <p>Agenda & Speakers</p>
        </div>
        <div onClick={() => navigateTo(routes.programme)}>
          <img src={fixedAssets.programmeNav} alt="nav icon" />
          <p>Programme</p>
        </div>
        <div onClick={() => navigateTo(routes.programme)}>
          <img src={fixedAssets.auditoriumNav} alt="nav icon" />
          <p>Auditorium</p>
        </div>
        <div onClick={() => handleNavClick("exhibition")}>
          <img src={fixedAssets.boothNav} alt="nav icon" />
          <p>Exhibition</p>
        </div>
        {/* <div onClick={()=> handleNavClick("helpdesk")}>
          <img src={fixedAssets.helpdeskNav} alt="nav icon" />
          <p>Helpdesk</p>
        </div> */}
        <div onClick={() => handleNavClick('logout')}>
          <img src={fixedAssets.logoutNav} alt="nav icon" />
          <p>Log Out</p>
        </div>
      </div>
      <div id="upIcon" className={`${showNav ? 'rotateDown' : 'rotateUp'}`}>
        <img onClick={toggleNav} src={fixedAssets.upArrow} width="30px" alt="up arrow icon" />
      </div>
      <div className="waviy" onClick={toggleNav}>
        <span style={{"--i" : "1" }}>C</span>
        <span style={{"--i" : "2" }}>l</span>
        <span style={{"--i" : "3" }}>i</span>
        <span style={{"--i" : "4" }}>c</span>
        <span style={{"--i" : "5" }}>k</span>
        <span style={{"--i" : "6" }}>&nbsp;&nbsp;</span>
        <span style={{"--i" : "7" }}>H</span>
        <span style={{"--i" : "8" }}>e</span>
        <span style={{"--i" : "9" }}>r</span>
        <span style={{"--i" : "10" }}>e</span>
        <span style={{"--i" : "11" }}>&nbsp;&nbsp;</span>
        <span style={{"--i" : "12" }}>T</span>
        <span style={{"--i" : "13" }}>o</span>
        <span style={{"--i" : "14" }}>&nbsp;&nbsp;</span>
        <span style={{"--i" : "15" }}>N</span>
        <span style={{"--i" : "16" }}>a</span>
        <span style={{"--i" : "17" }}>v</span>
        <span style={{"--i" : "18" }}>i</span>
        <span style={{"--i" : "19" }}>g</span>
        <span style={{"--i" : "20" }}>a</span>
        <span style={{"--i" : "21" }}>t</span>
        <span style={{"--i" : "22" }}>e</span>
      </div>
    </Wrapper>
  )
}
